var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"border-base radius-base pd-l-min pd-r-min pd-t-min pd-b-min"},[_c('div',{ref:"editorContainer",staticClass:"app-editor-container"})])
}
var staticRenderFns = []

export { render, staticRenderFns }